'use client';

import { cn } from '../../../../lib/utils';
import {
  Segmented,
  SegmentedContainer,
  SegmentedItem,
} from '../../navigation/segmented-control/SegmentedControl';
import { ColorPickerMode, useColorPickerContext } from './color-picker-context';

export interface ColorPickerModeSwitchProps {
  className?: string;
  /** None 세그먼트 표시 여부 */
  isShowNone?: boolean;
  /** Gradient 세그먼트 비활성화 여부 */
  isGradientDisabled?: boolean;
}

type SegmentValue = 'none' | ColorPickerMode;

export function ColorPickerModeSwitch({
  className,
  isShowNone = true,
  isGradientDisabled = false,
}: ColorPickerModeSwitchProps) {
  const { mode, onModeChange, isNone, onChange, lastSolidColor } =
    useColorPickerContext();

  const showGradient = !!onModeChange;
  const currentValue: SegmentValue = isNone ? 'none' : mode;

  const handleValueChange = (value: string) => {
    const v = value as SegmentValue;

    if (v === 'none') {
      onChange(null);
      return;
    }

    if (isNone) {
      onChange(lastSolidColor);
    }
    onModeChange?.(v);
  };

  return (
    <Segmented
      value={currentValue}
      onValueChange={handleValueChange}
      size="sm"
      className={cn('w-full', className)}
    >
      <SegmentedContainer className="border border-sys-style-neutral-default bg-sys-style-neutral-light">
        {isShowNone && <SegmentedItem value="none">None</SegmentedItem>}
        <SegmentedItem value="solid">Solid</SegmentedItem>
        {showGradient && (
          <SegmentedItem
            value="gradient"
            isDisabled={isGradientDisabled}
          >
            Gradient
          </SegmentedItem>
        )}
      </SegmentedContainer>
    </Segmented>
  );
}
